var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRedondo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00413B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5958 47.9639C25.7058 47.9639 20.9323 43.1904 20.9323 37.3004V21.2114C26.8222 21.2114 31.5958 25.985 31.5958 31.8725V47.9615V47.9639Z",
    fill: "#33993F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0953 17.3232L37.3822 19.4189C33.677 20.2177 31.3191 23.87 32.1179 27.5777L32.5847 29.7407L42.3001 27.645C46.0054 26.8462 48.3633 23.1939 47.5645 19.4862L47.0977 17.3232H47.0953Z",
    fill: "#DFA41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRedondo);
export default __webpack_public_path__ + "static/media/logo_redondo.d2359396b43da52d5117a62dd8daa2db.svg";
export { ForwardRef as ReactComponent };